// Días de calendario locales (YYYY-MM-DD) para las marcas que guarda el
// navegador: primera visita, última visita, último día de juego.
export function localDay(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function shiftDay(day: string, days: number): string {
  const [y, m, d] = day.split("-").map(Number);
  return localDay(new Date(y, m - 1, d + days));
}

// Lunes de la semana de un día (mismo corte que las cohortes del server).
export function weekOf(day: string): string {
  const [y, m, d] = day.split("-").map(Number);
  const date = new Date(y, m - 1, d);
  return shiftDay(day, -((date.getDay() + 6) % 7));
}
